import { showPage } from './kerne.js';
import { esc } from '../lib/tekst.js';
import { sb } from '../lib/supabase.js';

export async function checkMachineVideoCount(mcId, sku) {
  const { data } = await sb.from('video_machine_tags').select('video_id').eq('sku', sku);
  if (data?.length) { const btn=document.getElementById('vidbtn-'+mcId); if (btn) { btn.style.display='inline-flex'; btn.textContent='🎬 Vejledninger ('+data.length+')'; } }
}

export async function showMachineVideos(mcId, name, sku) {
  document.getElementById('mvTitle').textContent = name;
  document.getElementById('mvSku').textContent = 'Varenr.: ' + sku;
  showPage('machine-videos');
  const list = document.getElementById('machineVideoList');
  list.innerHTML = '<div class="spin">Henter videoer…</div>';
  const { data: tags } = await sb.from('video_machine_tags').select('video_id').eq('sku', sku);
  if (!tags?.length) { list.innerHTML='<div class="empty"><div class="ei">🎬</div><p>Ingen vejledningsvideoer til denne maskine endnu.</p></div>'; return; }
  const ids = tags.map(t => t.video_id);
  const { data: videos } = await sb.from('videos').select('*, video_categories(name)').in('id', ids).order('sort_order');
  if (!videos?.length) { list.innerHTML='<div class="empty"><div class="ei">🎬</div><p>Ingen vejledningsvideoer til denne maskine endnu.</p></div>'; return; }
  list.innerHTML = renderVideoGrid(videos);
}

export async function loadVideoPage() {
  const content = document.getElementById('videoPageContent');
  content.innerHTML = '<div class="spin">Henter videoer…</div>';
  const { data: cats } = await sb.from('video_categories').select('*').order('sort_order');
  const { data: videos } = await sb.from('videos').select('*, video_categories(name)').order('sort_order');
  if (!videos?.length) { content.innerHTML='<div class="empty"><div class="ei">🎬</div><p>Ingen videoer endnu.</p></div>'; return; }
  let html = '';

  // Featured videoer øverst
  const featured = videos.filter(v => v.is_featured);
  if (featured.length) {
    html += `<div class="vid-cat">
      <div class="vid-cat-title" style="display:flex;align-items:center;gap:7px">
        <span style="color:var(--orange)">★</span> Udvalgte videoer
      </div>
      <div class="vid-grid">${renderVideoGrid(featured)}</div>
      <a href="https://www.youtube.com/@dk-tec" target="_blank" rel="noopener"
        style="display:flex;align-items:center;justify-content:space-between;margin-top:14px;padding:12px 16px;background:#fff;border:1px solid var(--bdr);border-radius:var(--rl);text-decoration:none;color:inherit;transition:all .18s;box-shadow:0 1px 4px rgba(0,0,0,.05)"
        onmouseover="this.style.transform='translateY(-1px)';this.style.boxShadow='0 3px 12px rgba(0,0,0,.1)'"
        onmouseout="this.style.transform='';this.style.boxShadow='0 1px 4px rgba(0,0,0,.05)'">
        <div style="display:flex;align-items:center;gap:10px">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="#ff0000"><path d="M21.8 8.001a2.75 2.75 0 0 0-1.937-1.948C18.2 5.6 12 5.6 12 5.6s-6.2 0-7.863.453A2.75 2.75 0 0 0 2.2 8.001 28.8 28.8 0 0 0 1.75 12a28.8 28.8 0 0 0 .45 3.999 2.75 2.75 0 0 0 1.937 1.948C5.8 18.4 12 18.4 12 18.4s6.2 0 7.863-.453a2.75 2.75 0 0 0 1.937-1.948A28.8 28.8 0 0 0 22.25 12a28.8 28.8 0 0 0-.45-3.999zM9.75 15.02V8.98L15.5 12l-5.75 3.02z"/></svg>
          <div>
            <div style="font-family:'Oswald',sans-serif;font-size:13px;font-weight:600;letter-spacing:1px;text-transform:uppercase;color:var(--txt)">Se alle videoer på YouTube</div>
            <div style="font-size:12px;color:var(--txt-m);margin-top:1px">DK·TEC kanalen — vejledninger, demonstrationer og mere</div>
          </div>
        </div>
        <div style="font-size:20px;color:var(--txt-m)">›</div>
      </a>
    </div>`;
  }

  (cats || []).forEach(cat => {
    const catVids = videos.filter(v => v.category_id === cat.id);
    if (!catVids.length) return;
    html += `<div class="vid-cat"><div class="vid-cat-title">${esc(cat.name)}</div><div class="vid-grid">${renderVideoGrid(catVids)}</div></div>`;
  });
  const uncatVids = videos.filter(v => !v.category_id);
  if (uncatVids.length) html += `<div class="vid-cat"><div class="vid-cat-title">Øvrige</div><div class="vid-grid">${renderVideoGrid(uncatVids)}</div></div>`;
  content.innerHTML = html || '<div class="empty"><div class="ei">🎬</div><p>Ingen videoer endnu.</p></div>';
}

export function renderVideoGrid(videos) {
  return videos.map(v => {
    const thumb = v.thumbnail || `https://img.youtube.com/vi/${v.youtube_id}/mqdefault.jpg`;
    return `<a class="vid-card" href="https://www.youtube.com/watch?v=${v.youtube_id}" target="_blank" rel="noopener">
      <img class="vid-thumb" src="${esc(thumb)}" alt="${esc(v.title)}" loading="lazy">
      <div class="vid-info"><div class="vid-title">${esc(v.title)}</div>${v.description?`<div class="vid-desc">${esc(v.description)}</div>`:''}</div>
      <div class="vid-arr">›</div></a>`;
  }).join('');
}
